import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SessionService } from '../../Util/Session/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { ApprovalMatrixService } from '../../Model/ApprovalMatrix/approval-matrix.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ApprovalMatrixFormFilterComponent } from '../../Setting/ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { UtilityService } from '../../Model/utility/utility.service';
import { CompanyPolicyMasterService } from '../../Model/CompanyDocument/company-policy-master.service';

@Component({
  selector: 'app-company-policy-master-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbTooltip, NgbDatepickerModule, LoaderComponent],
  providers: [DatePipe,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './company-policy-master-form.component.html',
  styleUrl: './company-policy-master-form.component.scss'
})
export class CompanyPolicyMasterFormComponent {
  isDisabled: boolean = false;
  user = [] as any;
  CompanyPolicyLoad: any[] = [];
  Applicabilitys = [] as any;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  LastWebESSApplicabilityId = null;

  DetailDate = {
    SelectType: 'Insert',
    Aknowledgement: false,
    ESS_CompanyPolicyMasterID: 0 as any,
    AllowtoEdit: false,
    Allowtodownload: false,
    Active: true,
    ValidTillDate: null as any,
    ValidTillDateObj: null as any,
    DocumentAttachment: null,
    UserId: 0,
    ESS_CompanyPolicyTypeMasterID: null as any,
    Description: null,
    ESS_CompanyPolicyTitle: null,

    IsTrainingVideo: false,
    TrainingURL: null,
    Icon: null,

    EmpType: 'FRONT',
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  States = [] as any;
  StatesFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  selectedFile: File | null = null;
  selectedIcon: File | null = null;
  ImageUrl: any;
  Icon: any
  Icon1: any
  Image: any;
  constructor(
    private session: SessionService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected tooltip: TooltipService,
    private approvalMatrix: ApprovalMatrixService,
    private combo: ComboService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
    private companypolicy: CompanyPolicyMasterService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.DetailDate.UserId = this.user.UserId;
    this.route.params.subscribe((params: { [x: string]: string; }) => this.DetailDate.ESS_CompanyPolicyMasterID = parseInt(params['id']));
  }

  ngOnInit(): void {
    this.ComboLoad('CompanyPolicyType');
    if (this.DetailDate.ESS_CompanyPolicyMasterID > 0) {
      this.ESS_CompanyPolicyLoad();
    } else {
      this.GetApplicability();
    }
  }
  Validate(form: any) {
    if (form.valid) {
      this.ESS_CompanyPolicy();
    }
    else {
      form.submitted = true;
    }
  }

  async ESS_CompanyPolicy() {
    await this.common.getPageRights();
    this.SearchDropdown('', 'Applicability');
    if (this.DetailDate.ESS_CompanyPolicyMasterID === '' || this.DetailDate.ESS_CompanyPolicyMasterID === null) {
      this.toast.show({ message: 'Please select Company Type', type: toastTypeEnum.warning });
    } else if (this.DetailDate.ValidTillDateObj == '' && this.DetailDate.ValidTillDateObj == null) {
      this.toast.show({ message: 'Please Valid Till Date', type: toastTypeEnum.warning });
    }
    //  else if (this.DetailDate.DocumentAttachment == '' && this.DetailDate.DocumentAttachment == null) {
    //   this.toast.show({ message: 'Please attach Document', type: toastTypeEnum.warning });
    // } 
    else if (this.DetailDate.IsTrainingVideo && (this.DetailDate.TrainingURL == null || this.DetailDate.TrainingURL == '')) {
      this.toast.show({ message: 'Please enter Traning url', type: toastTypeEnum.warning });
    } else if (!this.DetailDate.IsTrainingVideo && (this.DetailDate.DocumentAttachment == null || this.DetailDate.DocumentAttachment == '')) {
      this.toast.show({ message: 'Please attach Document', type: toastTypeEnum.warning });
    } else if (this.DetailDate.EmpType != 'FRONT' && this.DetailDate.EmpType != 'BACK') {
      this.toast.show({ message: 'Please select applicable for', type: toastTypeEnum.warning });
    } else if (this.DetailDate.WebESSApplicabilityId == null) {
      this.toast.show({ message: "Please select applicability", type: toastTypeEnum.warning });
    } else if (this.DetailDate.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: "Please select sub applicability", type: toastTypeEnum.warning });
    }
    else {
      this.DetailDate.ValidTillDate = this.dateFormate.format(this.DetailDate.ValidTillDateObj);
      this.DetailDate.TrainingURL = this.DetailDate.IsTrainingVideo ? this.DetailDate.TrainingURL : null;
      this.DetailDate.DocumentAttachment = !this.DetailDate.IsTrainingVideo ? this.DetailDate.DocumentAttachment : null;
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.DetailDate.ESS_CompanyPolicyMasterID == 0) || (this.common.PageRight.IsEdit && this.DetailDate.ESS_CompanyPolicyMasterID > 0)) {
          if (result) {
            this.isDisabled = true;
            this.DetailDate.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.DetailDate.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString();
            this.companypolicy.CompanyPolicyMaster_Insert(this.DetailDate).subscribe({
              next: (response) => {
                if (response.Error_Code == "01") {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                  this.close();
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      });
    }
  }

  ESS_CompanyPolicyLoad() {
    this.isDisabled = true;
    this.companypolicy.CompanyPolicyMaster_Select({ SelectType: 1, ESS_CompanyPolicyMasterID: this.DetailDate.ESS_CompanyPolicyMasterID, OfficeType: '' }).subscribe({
      next: (response) => {
        this.ImageUrl = response.Table[0].DocumentAttachmentLink;
        this.Icon = response.Table[0].Iconlink;
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          response.Table[0].EmpType = 'FRONT';
        } else {
          response.Table[0].EmpType = response.Table[0].EmpType.toUpperCase();
        }
        this.DetailDate = response.Table[0];
        this.DetailDate.ValidTillDateObj = this.dateFormate.parse(this.DetailDate.ValidTillDate);
        this.DetailDate.MappedId = response.Table2.map((e: any) => e.MappedId).toString();
        this.DetailDate.SelectType = 'update';
        this.LastWebESSApplicabilityId = this.DetailDate.WebESSApplicabilityId;

        if (this.DetailDate.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.DetailDate.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.DetailDate.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.DetailDate.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.DetailDate.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.DetailDate.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.DetailDate.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.DetailDate.WebESSApplicabilityId == 8) {
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.DetailDate.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        }
        if (this.DetailDate.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'CompanyPolicyType') {
          this.CompanyPolicyLoad = response.ComboLoad;
          this.isDisabled = false
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  close() {
    this.router.navigate(['/companydocument/companypolicymaster/']);
  }
  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }
  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.DetailDate.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }
  async ApplicabilityDataFilter(IsFilter = false) {
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.DetailDate.MappedId = null;
        this.LastWebESSApplicabilityId = this.DetailDate.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.DetailDate.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.DetailDate.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.DetailDate.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.DetailDate.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.DetailDate.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.DetailDate.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.DetailDate.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }
  
  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.ClientGroupMasterID,
                ApplicabilityData: element.ClientGroupName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.SiteMasterID,
                ApplicabilityData: element.SiteName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                IsCheck: this.DetailDate.MappedId != null ? this.DetailDate.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.DetailDate.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent);
    modalRef.componentInstance.Title = this.DetailDate.WebESSApplicabilityId == 3 ? 'Client' : this.DetailDate.WebESSApplicabilityId == 4 ? 'Site' : this.DetailDate.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.DetailDate.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.DetailDate.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.DetailDate.WebESSApplicabilityId == 3 || this.DetailDate.WebESSApplicabilityId == 4 || this.DetailDate.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.DetailDate.WebESSApplicabilityId == 4 || this.DetailDate.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.DetailDate.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.DetailDate.WebESSApplicabilityId == 8) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.DetailDate.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.DetailDate.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.DetailDate.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.DetailDate.WebESSApplicabilityId == 4) {
        this.ApprovalComboLoad('Site');
      } else if (this.DetailDate.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.DetailDate.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.DetailDate.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.DetailDate.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.DetailDate.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }
  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }
  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.DetailDate.WebESSApplicabilityId == 3 || this.DetailDate.WebESSApplicabilityId == 4 || this.DetailDate.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }
  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }
  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.DetailDate.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.DetailDate.WebESSApplicabilityId).length == 0) {
          this.DetailDate.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.DetailDate.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  removeFile(type: string) {
    if (type === 'File') {
      this.selectedFile = null;
      this.DetailDate.DocumentAttachment = null;
      const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    }
    else if (type === 'Icon') {
      this.selectedIcon = null;
      this.DetailDate.Icon = null;
      const fileInput = document.getElementById('FileSm') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    }
  }
  viewFile(type: string) {
    if (type === 'File') {
      window.open(this.ImageUrl, '_blank');
    }
    else if (type === 'Icon') {
      window.open(this.Icon, '_blank');
    }
  }
  onFileSelected(event: any, type: string) {
    this.isDisabled = true
    if (type === 'File') {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        this.selectedFile = input.files[0];
      }
      if (this.selectedFile) {
        this.uploadToFTP(this.selectedFile, type);
      } else {
        this.isDisabled = false;
      }
    }
    else if (type === 'Icon') {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        this.selectedIcon = input.files[0];
      }
      if (this.selectedIcon) {
        this.uploadToFTP(this.selectedIcon, type);
      }
      else {
        this.isDisabled = false;
      }
    }
  }
  uploadToFTP(file: File, type: string) {
    if (!file) {
      return;
    }
    this.isDisabled = true
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': 'CompanyDocument', 'CompanyCode': this.user.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          if (type === 'File') {
            this.DetailDate.DocumentAttachment = response.FileName;
            this.ImageUrl = response.Url;
            this.isDisabled = false;
          }
          else if (type === 'Icon') {
            this.DetailDate.Icon = response.FileName;
            this.Icon = response.Url;
            this.isDisabled = false;
          }
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
          this.isDisabled = false;
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }

  // IconSelected(event: any) {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length > 0) {
  //     this.selectedIcon = input.files[0];
  //   }
  //   if (this.selectedIcon) {
  //     if (!this.selectedIcon) {
  //       return;
  //     }
  //     const reader = new FileReader();
  //     reader.readAsDataURL(this.selectedIcon);
  //     reader.onload = () => {
  //       this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': 'CompanyDocument', 'CompanyCode': this.user.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
  //         if (response.FileName != "") {
  //           this.DetailDate.Icon = response.FileName;
  //           this.Icon = response.Url;
  //         } else {
  //           this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
  //         }
  //         this.isDisabled = false;
  //       }, (error) => {
  //         console.error('FTP Upload Error:', error);
  //         this.isDisabled = false;
  //       });
  //     };
  //     this.isDisabled = false;
  //   } else {
  //     this.isDisabled = false;
  //   }
  // }
}
